var map = {
	"vs/language/css/cssWorker": 126,
	"vs/language/html/htmlWorker": 145,
	"vs/language/json/jsonWorker": 157,
	"vs/language/typescript/src/worker": 171
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/editor/common/services
// module id = 125
// module chunks = 0